import { ActivityIndicator, ActivityIndicatorProps } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

import { Theme, ThemeColorName } from '@/styles/theme'

const BaseActivityIndicator = withUnistyles(ActivityIndicator)

type ThemedActivityIndicatorProps = Omit<ActivityIndicatorProps, 'key'>

export type UniActivityIndicatorProps = ActivityIndicatorProps & {
  colorName?: ThemeColorName
  getThemeProps?: (theme: Theme) => Partial<ThemedActivityIndicatorProps>
}

const UniActivityIndicator = ({
  color,
  colorName,
  getThemeProps,
  ...rest
}: UniActivityIndicatorProps) => {
  return (
    <BaseActivityIndicator
      {...rest}
      color={color}
      uniProps={(theme) => ({
        ...(color || !colorName ? {} : { color: theme.colors[colorName] }),
        ...getThemeProps?.(theme),
      })}
    />
  )
}

export default UniActivityIndicator
